import  { useState } from "react";
import CrossIcon from "../../../../assets/icons/maid-module-icons/CrossIcon.svg";
import DigitalPassIcon from "../../../../assets/icons/maid-module-icons/DigitalPass.svg";
import AadhaarCard from "../../../../assets/img/aadhaarCard.svg";
import AadhaarImg from "../../../../assets/icons/maid-module-icons/AadhaarImg.svg";
import DigitalPassCard from "./DigitalPass";
import ImagePreviewModal from "../../modals/modals/ImagePreviewModal";
import flatIcon from "../../../../assets/icons/maid-module-icons/buildingsIcon.svg"

const DigitalPassGenerator = ({ show, onHide, staffData }) => {
  const [showPassCard, setShowPassCard] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [previewUrl, setPreviewUrl] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");

  if (!show) return null;

  console.log("staff Data is",staffData)


  const {
    name = "—",
    mobileNumber = "—",
    gender = "—",
    role = "",
    roleName = "",
    flats = "—",
    selectedFlats,
    curoNextId = "Pending Approval",
    documentNumber = "",
    documentType = "",
  } = staffData || {};

  const profileSrc = staffData?.profileImage
    ? URL.createObjectURL(staffData.profileImage)
    : "https://i.pravatar.cc/150?img=68";

  const maskedDoc = documentNumber?.length >= 4
    ? `**** **** ${documentNumber.slice(-4)}`
    : "Not provided";

  const openPreview = (source, title) => {
    let url;
    if (source instanceof File) {
      url = URL.createObjectURL(source);
    } else {
      url = source;
    }
    setPreviewUrl(url);
    setPreviewTitle(title);
    setShowModal(true);
  };

  const handleClosePreview = () => {
    setShowModal(false);
    if (previewUrl && previewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(previewUrl);
    }
    setPreviewUrl("");
    setPreviewTitle("");
  };

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1100,         
        }}
      />

      {/* Modal container  */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 1110,          
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          className="bg-white d-flex flex-column"
          style={{
            width: "50%",
            maxWidth: 600,
            height: "96vh",
            borderRadius: 18,
            overflow: "hidden",
            fontFamily: "Inter, sans-serif",
            position: "relative",  
          }}
        >
          {/* Header */}
          <div
            className="d-flex justify-content-between align-items-center px-4 py-3 text-white"
            style={{ backgroundColor: "#1C80D2" }}
          >
            <div className="d-flex align-items-center gap-2">
          
              <h5 className="mb-0">Service Staff Details</h5>
            </div>
            <button
              className="btn p-0 d-flex align-items-center justify-content-center bg-white"
              style={{ width: 24, height: 24, borderRadius: 6 }}
              onClick={onHide}
            >
              <img src={CrossIcon} alt="cross" />
            </button>
          </div>

          {/* Body */}
          <div
            className="flex-grow-1 px-4 py-4"
            style={{
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
            }}
          >
            {/* Profile Section */}
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                marginBottom: 24,
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
              <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 8,
                      alignItems: "center",
                      width: 85,         
                      flexShrink: 0       
                    }}
                  >
                <img
                      src={profileSrc}
                      alt="Profile"
                      onClick={() => openPreview(staffData?.profileImage || profileSrc, "Profile Photo")}
                      style={{
                        width: 85,
                        height: 85,
                        borderRadius: "50%",
                        border: "2px solid #e5e7eb",
                        cursor: "pointer",
                        objectFit: "cover",
                      }}
                    />

                    <div
                      style={{
                        fontSize: 16,
                        color: "#070707",
                        fontWeight: 500,
                        textAlign: "center",
                        width: "100%",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                      }}
                    >
                      {roleName || "-"}
                    </div>
                  </div>


                <div>
                     <div style={{ marginTop: -35, fontWeight: 600, fontSize: 18 }}>
                    <label className="form-label fw-bold ">{name}</label>

                  </div>
                    <div style={{ fontSize: 13, color: "#6b7280", marginTop: 2 }}>
                    {mobileNumber}
                  </div>
                  <div
                    style={{
                      fontSize: 13,
                      color: "#6b7280",
                      fontWeight: 500,
                      marginTop: 2,
                    }}
                  >
                    {gender}
                  </div>
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <button
                  onClick={() => setShowPassCard(true)}
                  style={{
                    background: "none",
                    border: "none",
                    color: "#00579E",
                    fontSize: 13,
                    fontWeight: 600,
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 4,
                    padding: 0,
                  }}
                >
                  <img
                    src={DigitalPassIcon}
                    alt="Digital Pass"
                    style={{ width: 28, height: 28 }}
                  />
                  Digital Pass
                </button>
              </div>
            </div>

            {/* CuroNext ID */}
            <div style={{ marginBottom: 24 }}>
              <div
                style={{
                  position: "relative",
                  border: "2px solid #EDEDED",
                  borderRadius: 12,
                  padding: "40px 16px 24px",
                  background: "#f0f9ff",
                }}
              >
                <div
                  style={{
                    position: "absolute",
                    top: 10,
                    left: 16,
                    background: "#f0f9ff",
                    padding: "0 6px",
                    fontSize: 12,
                    fontWeight: 500,
                    color: "#454545",
                  }}
                >
                  CuroNext ID (Pass Code)
                </div>

               <div
                  style={{
                    border: "3px dashed #2295D2",
                    borderRadius: 12,
                    padding: "24px 16px",
                    textAlign: "center",
                    background: "#f0f9ff",
                    width: "50%",
                    margin: "0 auto",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: "10px",
                      fontSize: "clamp(20px, 6vw, 22px)",
                      fontWeight: "bold",
                      color: "#2295D2",
                    }}
                  >
                    {(() => {
                      const code = String(curoNextId || "-");
                      if (code === "-") return <span>{code}</span>;
                      const chunks = code.match(/.{1,3}/g) || [];
                      return chunks.map((chunk, index) => (
                        <span
                          key={index}
                          style={{
                            letterSpacing: 5,
                          }}
                        >
                          {chunk}
                        </span>
                      ));
                    })()}
                  </div>
                </div>
              </div>
            </div>

            {/* Document Details */}
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#595757",
                  marginBottom: 12,
                }}
              >
                Document Details
              </label>
              <div
                style={{
                  background: "#fff",
                  border: "1px solid #e5e7eb",
                  borderRadius: 12,
                  padding: 16,
                }}
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    fontSize: 13,
                    color: "#111827",
                    marginBottom: 12,
                    fontWeight: 500,
                  }}
                >
                  <img
                    src={AadhaarCard}
                    alt="Aadhaar"
                    style={{
                      width: 35,
                      height: "auto",
                      borderRadius: 6,
                      objectFit: "cover",
                    }}
                  />
                  <span>{documentType}</span>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
                  {staffData?.documentFile ? (
                    <img
                      src={URL.createObjectURL(staffData.documentFile)}
                      alt="Uploaded document"
                      onClick={() => openPreview(staffData.documentFile, "Document Preview")}
                      style={{
                        width: 150,
                        height: "auto",
                        borderRadius: 6,
                        objectFit: "cover",
                        cursor: "pointer",
                      }}
                    />
                  ) : (
                    <img
                      src={AadhaarImg}
                      alt="Aadhaar placeholder"
                      style={{
                        width: 150,
                        height: "auto",
                        borderRadius: 6,
                        objectFit: "cover",
                      }}
                    />
                  )}

                  <div
                    style={{
                      fontSize: 17,
                      fontWeight: 700,
                      color: "#111827",
                      letterSpacing: 1,
                      whiteSpace: "nowrap",
                    }}
                  >
                    {maskedDoc}
                  </div>
                </div>
              </div>
            </div>

            {/* Flats */}
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  display: "block",
                  fontSize: 13,
                  fontWeight: 500,
                  color: "#6b7280",
                  marginBottom: 12,
                }}
              >
                Flats
              </label>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 10,
                  padding: "12px 14px",
                  border: "1px solid #e5e7eb",
                  borderRadius: 8,
                  fontSize: 14,
                  color: "#111827",
                  background: "#fff",
                }}
              >
          
                <img 
                    src={flatIcon} 
                    alt="Flat Icon" 
                    width="18" 
                    height="18" 
                    className="img-fluid"
                  />
               <div style={{ flex: 1, display: "flex", flexWrap: "wrap", gap: 8 }}>
                  {selectedFlats && selectedFlats.length > 0 ? (
                    selectedFlats.map((flat, index) => (
                      <div
                        key={index}
                        style={{
                          display: "inline-flex",
                          alignItems: "center",
                          gap: 6,
                          padding: "6px 12px",
                          background: "#ffffff",
                          border: "1px solid #e5e7eb",
                          borderRadius: 6,
                          fontSize: 13,
                          fontWeight: 500,
                        }}
                      >
                        <span style={{ color: "#6b7280" }}>
                          {flat.towerName || flat.towerNo || `Tower ${flat.towerId || ""}`}
                        </span>
                        <span style={{ color: "#d1d5db" }}>•</span>
                        <span style={{ color: "#374151" }}>
                          {flat.flatNo || flat.flatName || `Flat ${flat.flatId || ""}`}
                        </span>
                      </div>
                    ))
                  ) : flats ? (
                    <span style={{ color: "#374151", fontSize: 14 }}>{flats}</span>
                  ) : (
                    <span style={{ color: "#9ca3af", fontSize: 14 }}>No flats assigned</span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Digital Pass Card Modal */}
      <DigitalPassCard
        show={showPassCard}
        onHide={() => setShowPassCard(false)}
        staffData={staffData}
      />

      <ImagePreviewModal
        show={showModal}
        imageUrl={previewUrl}
        onClose={handleClosePreview}
        title={previewTitle}
      />
    </>
  );
};

export default DigitalPassGenerator;